import React from 'react';
import { RoscoSVG } from '../components/svg/Rosco/index';
/**
 * Gráfica que muestra tres roscos con porcentajes
 */

const Rosco = React.memo(props => {
  return (
    <RoscoSVG
      centx={500}
      centy={500}
      rAct={400}
      rAnt={300}
      rAntAnt={200}
      porcentAct={props.porcAct}
      porcentAnt={props.porcAnt}
      porcentAntAnt={props.porcAntant}
      colorBckgrnd="grey"
      strokeAct="#00b0ac"
      strokeAnt="#768aa4"
      strokeAntAnt="#db979c"
      strokeWidthOut={40}
      strokeWidthIn={20}
      strokeLinecap="round"
      duration="1"
    />
  );
});

export default Rosco;